import Item from "./ChecklistItem.js";
import Model from "../../../Model.js";

/**
 * `Section` represents a list of todo items and is a part of a period
 * report's `Checklist`. The receiver is meant to be instantiated for
 * each period report from a `SectionTemplate`.
 *
 * @param {string} id - A guid used to uniquely identify the section
 * within its checklist template.
 * @param {Item[]} items - Collection of todo items related to the receiver.
 */
export default class ChecklistSection extends Model {
	constructor({ id = null, items = [] } = {}) {
		super(...arguments);
		this._id = id;
		this._items = items;
	}

	getId() {
		return this._id;
	}

	getItems() {
		return this._items;
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.items = Item.materializeAll(data.items, context);
	}
}
